{
  "metrics": {
    "totalCustomers": "Clients au total",
    "thisMonth": "ce mois-ci",
    "weeklyActive": "Actifs/semaine",
    "monthlyActive": "Actifs mensuels",
    "ofTotalCustomers": "{{percent}} % du total des clients"
  }
}
